import { Injectable } from '@angular/core';
import { NetworkHelper } from '@wm-libs/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PrivacyPolicy, TermsOfUse } from '../interfaces/privacy-terms.interface';

@Injectable({
  providedIn: 'root',
})
export class PrivacyTermsService {
  readonly apiTermsUrl = `${environment.poolApi}/terms-of-use`;
  readonly apiPrivacyUrl = `${environment.poolApi}/privacy-policy`;

  constructor(private networkHelper: NetworkHelper) {}

  getTerms(): Observable<TermsOfUse> {
    return this.networkHelper.get<TermsOfUse>(`${this.apiTermsUrl}`);
  }

  getPrivacy(): Observable<PrivacyPolicy> {
    return this.networkHelper.get<PrivacyPolicy>(`${this.apiPrivacyUrl}`);
  }
}
